import React from 'react';
import { TopBadge } from './components/TopBadge';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { ForWho } from './components/ForWho';
import { SystemPresentation } from './components/SystemPresentation';
import { GuidesAccordion } from './components/GuidesAccordion';
import { BonusCards } from './components/BonusCards';
import { Comparison } from './components/Comparison';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="w-full min-h-screen bg-violet-deep" data-id="element-0">
      <TopBadge data-id="element-1" />
      <Hero onCTAClick={scrollToPricing} data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <ForWho data-id="element-5" />
      <SystemPresentation data-id="element-6" />
      <GuidesAccordion data-id="element-7" />
      <BonusCards data-id="element-8" />
      <Comparison data-id="element-9" />
      <Urgency data-id="element-10" />
      <Pricing data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <FinalCTA onCTAClick={scrollToPricing} data-id="element-14" />
      <Footer data-id="element-15" />
      <PurchasePopup data-id="element-16" />
      <MetaPixel data-id="element-17" />
    </div>;
}